module.exports = __webpack_public_path__ + "media/3-11.602ee765.wav";